import React, { useEffect, useState } from 'react';

// bootstrap
import Button from 'react-bootstrap/Button';

// styling
import { Spacing, Colors } from '_styles';

// icons
import { FaArrowCircleUp } from "react-icons/fa";
import { FaShoppingCart } from 'react-icons/fa';

// custom components 
import { ShoppingCart } from '_components/organisms';

const CheckoutButton = (props) => {

    const [showModal, setShowModal] = useState(false);

    return (
        <div style={styles.buttonContainer}>
            <div>

                {/* open cart button */}
                <Button
                    style={styles.button}
                    onClick={() => setShowModal(true)}
                    variant="primary"
                    disabled={props.loading || props.error ? true : false}
                >

                    <div style={{ flex: 1, display: 'flex' }}>

                        {/* shopping cart icon */}
                        <div style={{ flex: 0.25 }}>

                            <FaShoppingCart size={Spacing.SCALE_22} style={styles.icon} onClick={() => setShowModal(true)} />

                        </div>

                        <div style={{ flex: 1 }}>
                            View Cart {props?.cartQuantity > 0 ? `(${props?.cartQuantity})` : ''}
                        </div>

                    </div>

                </Button>
            </div>

            {/* scroll button */}
            {props.showScrollTop && (
                <div style={styles.scrollTopWrapper}>
                    <Button
                        style={styles.scrollTopButton}
                        onClick={props.scrollToTop}
                        variant="primary"
                    >
                        <FaArrowCircleUp color={'white'} size={48} style={{ fontWeight: 'bold' }} />
                    </Button>
                </div>
            )}

            {
                showModal && (
                    <ShoppingCart showModal={showModal} setShowModal={setShowModal} />
                )
            }

        </div>
    );
};

const styles = {
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
    },
    button: {
        padding: Spacing.SCALE_12,
        width: Spacing.SCALE_160,
        borderRadius: 25,
        boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.1)',
    },
    scrollTopButton: {
        alignSelf: 'center',
        borderRadius: '50%',
        width: Spacing.SCALE_60,
        height: Spacing.SCALE_60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    scrollTopWrapper: {
        position: 'absolute',
        right: Spacing.SCALE_8,
        bottom: Spacing.SCALE_12,
    },
    icon: {
        color: '#fff',
        cursor: 'pointer',
    },
}

export default CheckoutButton;
